import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useConfiguration } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import { BottomStripe } from '../../components/Footer/components/BottomStripe/index.js';
import { Container } from '../../components/Footer/components/Container.js';
import { Copyright } from '../../components/Footer/components/Copyright.js';
import { Legal } from '../../components/Footer/components/Legal.js';
import { Link } from '../../components/Footer/components/Links/components/Link/index.js';
import { useGenerateLink } from '../../components/hooks/useGenerateLink.js';
import { FOOTER_QA_ID, qaId } from '../../utils/qaId.js';
export const ShortWithLinks = ({
  shortLinks,
  path = '',
  brandName = 'ab in den urlaub'
}) => {
  const {
    t
  } = useTranslation(['footer']);
  const {
    generateLink
  } = useGenerateLink();
  const domain = useConfiguration('domain');
  return _jsx(Container, {
    "data-testid": qaId(FOOTER_QA_ID),
    children: _jsx(BottomStripe, {
      light: true,
      children: shortLinks.length > 0 && _jsxs(Legal, {
        extended: true,
        children: [_jsx(Copyright, {
          "data-testid": qaId(FOOTER_QA_ID, 'title', 'copyright'),
          children: t('copyright', {
            brandName: brandName,
            year: new Date().getFullYear()
          })
        }), shortLinks.map(({
          items
        }) => items.map(({
          label,
          url,
          masked,
          addCurrentPath,
          target
        }) => {
          return _jsx(Link, {
            href: generateLink(url || '', path, addCurrentPath),
            masked: masked,
            custom: true,
            target: target,
            children: t(label, {
              brandName,
              domain
            })
          }, `${label}-${url}`);
        }))]
      })
    })
  });
};